/**
 * 従業員店舗グループ共通関数
 *
 * @author hayakawa 2023.12.25
 */

// インポート
import { employee_auth_id_admin, employee_auth_id_sv, employee_auth_id_owner, employee_auth_id_manager, employee_auth_id_sub_manager, employee_auth_id_pjcrew, employee_auth_id_crew, employee_auth_id_linkage } from '../_constants';

// 定数
const $modal_employee_organization_group_index = $('#modal-employee-organization-group-index'),
    login_user_auth_id = $('#logout-form').find('input[type="hidden"][name="login_user_auth_id"]').val();

/**
 * 全店舗を作成する
 *
 * @return {void}
 * @author hayakawa 2023.11.15
 */
export const addAllEmployeeOrganizationsGroup = () => {
    const $li = '' +
        `<li class="d-flex">\n` +
            `<a class="" href="javascript:void(0);" data-employee_organization_group_id="all">全店舗</a>\n` +
        `</li>\n`;

    $modal_employee_organization_group_index.find('section.group-list').find('ol').append($($li).prop('outerHTML'));
}

/**
 * 登録済みの店舗グループ一覧を作成する
 *
 * @param {array} employee_organization_groups
 * @return {void}
 * @author hayakawa 2023.11.22
 */
export const addEmployeeOrganizationGroups = (employee_organization_groups = []) => {
    const is_view_mode = $('#btn-show-unlock-view-mode').is(':visible') ? ' is-view-mode' : '';

    $.each(employee_organization_groups, function(index, val) {
        const $li = '' +
            `<li class="d-flex">\n` +
                `<a class="" href="javascript:void(0);" data-employee_organization_group_id="${val.employee_organization_group_id}">${val.group_name}</a>\n` +
                `<button class="btn btn-sm btn-outline-secondary ml-auto mr-1 btn-show-employee-organization-group-edit${is_view_mode}" data-employee_organization_group_id="${val.employee_organization_group_id}">\n` +
                    `<i class="fas fa-edit"></i>\n` +
                    `<span>編集</span>\n` +
                `</button>\n` +
                `<button class="btn btn-sm btn-outline-secondary btn-delete-employee-organization-group${is_view_mode}" data-employee_organization_group_id="${val.employee_organization_group_id}">\n` +
                    `<i class="fas fa-trash"></i>\n` +
                    `<span>削除</span>\n` +
                `</button>\n` +
            `</li>\n`;

        $modal_employee_organization_group_index.find('section.group-list').find('ol').append($($li).prop('outerHTML'));
    });
}

/**
 * すべてを作成する
 *
 * @param {array} selected_organization_id
 * @return {void}
 * @author hayakawa 2023.11.22
 */
export const addAllOrganization = (selected_organization_id = '') => {
    const active = (selected_organization_id === 'all' || selected_organization_id === '0' || selected_organization_id === '') ? ' active' : '',
        $li = '' +
        `<li class="" data-company_id="all" data-organization_id="all">\n` +
            `<button type="button" class="btn btn-sm d-flex align-items-center w-100${active}">\n` +
                `<span class="fa-sm text-left w-50 organization-name">すべて</span>\n` +
                `<span class="fa-sm text-left w-50 organization-address"></span>\n` +
            `</button>\n` +
        `</li>\n`;

    $modal_employee_organization_group_index.find('section.organization-list').find('ol').append($($li).prop('outerHTML'));
}

/**
 * 登録済みの店舗一覧を作成する
 *
 * @param {array} can_select_organizations
 * @param {array} organization_ids
 * @param {string} selected_organization_id
 * @param {array} selected_organization_ids
 * @param {string} is_button
 * @param {string} is_check_single
 * @param {string} is_check_all
 * @param {string} is_check_multiple
 * @param {string} has_all
 * @param {string} is_force_used_only
 * @param {string} is_normal_only
 * @param {string} is_help_used_only
 * @return {void}
 * @author hayakawa 2023.11.20
 */
export const addOrganizations = (
    can_select_organizations = [],
    organization_ids = [],
    selected_organization_id = '',
    selected_organization_ids = [],
    is_button = '0',
    is_check_single = '0',
    is_check_all = '0',
    is_check_multiple = '0',
    has_all = '0',
    is_force_used_only = '0',
    is_normal_only = '0',
    is_help_used_only = '0'
) => {
    // 登録可能店舗繰り返し
    $.each(can_select_organizations, function(index, val) {

        // 登録済み店舗の場合
        if ($.inArray(String(val.organization_id), organization_ids) !== -1) {
            const can_display = canDisplay(val, is_force_used_only, is_normal_only, is_help_used_only);

            // 表示できる店舗の場合
            if (can_display) {

                // ボタンの場合
                if (is_button === '1') {
                    const active = String(val.organization_id) === String(selected_organization_id) ? ' active' : '',
                        $li = '' +
                        `<li class="" data-company_id="${val.company_id}" data-organization_id="${val.organization_id}">\n` +
                            `<button type="button" class="btn btn-sm d-flex align-items-center w-100${active}">\n` +
                                `<span class="fa-sm text-left w-50 organization-name">${val.organization_name}</span>\n` +
                                `<span class="fa-sm text-left w-50 organization-address">${val.organization_address}</span>\n` +
                            `</button>\n` +
                        `</li>\n`;

                    if (active) {
                        if (is_button === '1' && has_all === '1') {
                            $modal_employee_organization_group_index.find('section.organization-list').find('ol').find('li[data-organization_id="all"]').after($($li).prop('outerHTML'));
                        } else {
                            $modal_employee_organization_group_index.find('section.organization-list').find('ol').prepend($($li).prop('outerHTML'));
                        }
                    } else {
                        $modal_employee_organization_group_index.find('section.organization-list').find('ol').append($($li).prop('outerHTML'));
                    }
                // チェックボックスの場合
                } else {
                    // 1つだけチェックできる
                    if (is_check_single === '1') {
                        const checked = String(val.organization_id) === String(selected_organization_id) ? ' checked' : '',
                            $li = '' +
                            `<li class="" data-company_id="${val.company_id}" data-organization_id="${val.organization_id}">\n` +
                                `<div class="d-flex">\n` +
                                    `<label class="input-group-text bg-white border-0 w-50">\n` +
                                        `<input type="hidden" name="organization_ids[${val.organization_id}]" value="0">\n` +
                                        `<input type="checkbox" class="mr-1" name="organization_ids[${val.organization_id}]" value="1"${checked}>\n` +
                                        `<span class="fa-sm organization-name">${val.organization_name}</span>\n` +
                                    `</label>\n` +
                                    `<span class="fa-sm align-self-center w-50 organization-address">${val.organization_address}</span>\n` +
                                `</div>\n` +
                            `</li>\n`;

                        if (checked) {
                            $modal_employee_organization_group_index.find('section.organization-list').find('ol').prepend($($li).prop('outerHTML'));
                        } else {
                            $modal_employee_organization_group_index.find('section.organization-list').find('ol').append($($li).prop('outerHTML'));
                        }
                    // 複数チェックできる
                    } else if (is_check_multiple === '1') {
                        const checked = ($.inArray(String(val.organization_id), selected_organization_ids) !== -1 || $.inArray(Number(val.organization_id), selected_organization_ids) !== -1) ? ' checked' : '',
                            $li = '' +
                            `<li class="" data-company_id="${val.company_id}" data-organization_id="${val.organization_id}">\n` +
                                `<div class="d-flex">\n` +
                                    `<label class="input-group-text bg-white border-0 w-50">\n` +
                                        `<input type="hidden" name="organization_ids[${val.organization_id}]" value="0">\n` +
                                        `<input type="checkbox" class="mr-1" name="organization_ids[${val.organization_id}]" value="1"${checked}>\n` +
                                        `<span class="fa-sm organization-name">${val.organization_name}</span>\n` +
                                    `</label>\n` +
                                    `<span class="fa-sm align-self-center w-50 organization-address">${val.organization_address}</span>\n` +
                                `</div>\n` +
                            `</li>\n`;

                        if (checked) {
                            if ($modal_employee_organization_group_index.find('section.organization-list').find('ol').find('input[type="checkbox"]:checked').length > 0) {
                                $modal_employee_organization_group_index.find('section.organization-list').find('ol').find('input[type="checkbox"]:checked').last().closest('li').after($($li).prop('outerHTML'));
                            } else {
                                $modal_employee_organization_group_index.find('section.organization-list').find('ol').prepend($($li).prop('outerHTML'));
                            }
                        } else {
                            $modal_employee_organization_group_index.find('section.organization-list').find('ol').append($($li).prop('outerHTML'));
                        }
                    // 初期値はすべてチェックされている
                    } else if (is_check_all === '1') {
                        const $li = '' +
                            `<li class="" data-company_id="${val.company_id}" data-organization_id="${val.organization_id}">\n` +
                                `<div class="d-flex">\n` +
                                    `<label class="input-group-text bg-white border-0 w-50">\n` +
                                        `<input type="hidden" name="organization_ids[${val.organization_id}]" value="0">\n` +
                                        `<input type="checkbox" class="mr-1" name="organization_ids[${val.organization_id}]" value="1" checked>\n` +
                                        `<span class="fa-sm organization-name">${val.organization_name}</span>\n` +
                                    `</label>\n` +
                                    `<span class="fa-sm align-self-center w-50 organization-address">${val.organization_address}</span>\n` +
                                `</div>\n` +
                            `</li>\n`;

                        $modal_employee_organization_group_index.find('section.organization-list').find('ol').append($($li).prop('outerHTML'));
                    }
                }
            }
        }
    });
}

/**
 * 表示可能な店舗か
 *
 * @param {array} organization
 * @param {string} is_force_used_only
 * @param {string} is_normal_only
 * @param {string} is_help_used_only
 * @return {boolean}
 * @author hayakawa 2023.12.25
 */
export const canDisplay = (organization, is_force_used_only, is_normal_only, is_help_used_only) => {
    let can_display = true;

    // Force利用店舗のみ表示の場合
    if (is_force_used_only === '1') {
        if (String(organization.force_used_flag) !== '1') {
            can_display = false;
        }
    }

    // 通常店舗のみ表示（ヘルプ専門店と単店表示店は表示しない）の場合
    if (is_normal_only === '1') {
        if (Number(login_user_auth_id) !== employee_auth_id_admin) {
            if (String(organization.help_flag) === '1' && !organization.is_exception) {
                can_display = false;
            }
            if (String(organization.unit_display_flag) === '1' && !organization.is_exception) {
                can_display = false;
            }
        }
    }

    // ヘルプ利用店舗のみ表示の場合
    if (is_help_used_only === '1') {
        if (String(organization.use_help_flag) !== '1') {
            can_display = false;
        }
    }

    return can_display;
}
